// @ts-nocheck
import {InitPage} from "../index";

class IRMSInventoryRequests {
  constructor() {
    $('document').ready(function () {
      $('#from_date, #to_date').datepicker({ format: 'yyyy-mm-dd HH:ii p' });
      $('#from-date').on('click', function (e) {
        e.preventDefault();
        $('#from_date').datepicker('show');
      });
      $('#to-date').on('click', function (e) {
        e.preventDefault();
        $('#to_date').datepicker('show');
      });
      $('#export-btn').on('click', function (e) {
        $("#exportCSV").modal('show');
      });
    });

    $('.check-max-length').on('input', function () {
      var maxlength = parseInt($(this).attr('maxlength'));
      $(this).val($(this).val().toString().substring(0, maxlength));
    });
  }
}

export function LoadPage() {
  InitPage("inventory_requests index edit", () => {
    const c = new IRMSInventoryRequests();
  });
}